module.exports = __webpack_public_path__ + "static/img/order_empty.fb58ec9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/order_empty.png
// module id = 6Tka
// module chunks = 1